import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getMaterialFolders, getMaterialInstitutionFolders } from "../helper/apicalls/materials";
import MaterialFolderGrid from "../components/MaterialFolderGrid";
import "../styles/MaterialFolder.scss";
import GlobalLoader from "../components/GlobalLoader";

const MaterialsSubTopicContent = () => {
  const { subtopickey } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "course";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [courseFolders, setCourseFolders] = useState([]);
  const [institutionFolders, setInstitutionFolders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        let materialsRes = [];
        let instMaterialsRes = [];

        try {
          materialsRes = await getMaterialFolders({
            title: "subtopic",
            key: subtopickey || "",
          });
        } catch (e) {
          console.error("Failed to fetch subtopic materials:", e);
        }

        try {
          instMaterialsRes = await getMaterialInstitutionFolders({
            title: "subtopic",
            key: subtopickey || "",
          });
        } catch (e) {
          console.error("Failed to fetch subtopic institution materials:", e);
        }

        const materials = Array.isArray(materialsRes?.data)
          ? materialsRes.data
          : Array.isArray(materialsRes)
            ? materialsRes
            : [];
        const instMaterials = Array.isArray(instMaterialsRes?.data)
          ? instMaterialsRes.data
          : Array.isArray(instMaterialsRes)
            ? instMaterialsRes
            : [];

        const courseMaterialFolders = materials.map((m) => ({
          ...m,
          _kind: "material",
        }));
        const institutionMaterialFolders = instMaterials.map((m) => ({
          ...m,
          _kind: "institution_material",
        }));

        setCourseFolders([...courseMaterialFolders]);
        setInstitutionFolders([...institutionMaterialFolders]);
      } catch (e) {
        console.error("Failed to load materials for subtopic", e);
        setCourseFolders([]);
        setInstitutionFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (subtopickey) {
      fetchData();
    }
  }, [subtopickey]);

  const handleOpenFolder = (folder) => {
    if (!folder) return;
    if (folder._kind === "material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}`);
      return;
    }
    if (folder._kind === "institution_material" && (folder.id || folder._id)) {
      const folderId = folder.id || folder._id;
      navigate(`/materials-folder/${folderId}?type=institution`);
      return;
    }
  };

  const currentFolders = activeTab === "institution" ? institutionFolders : courseFolders;

  return (
    <div className="materials-page">
      <div className="materials-header">
        <h1 className="materials-title">Materials - Subtopic Content</h1>
      </div>

      <div className="materials-tabs">
        <button
          type="button"
          className={`materials-tab ${activeTab === "course" ? "active" : ""}`}
          onClick={() => setActiveTab("course")}
        >
          Course Resources
        </button>
        <button
          type="button"
          className={`materials-tab ${activeTab === "institution" ? "active" : ""}`}
          onClick={() => setActiveTab("institution")}
        >
          Institution Resources
        </button>
      </div>

      {loading ? (
        <GlobalLoader />
      ) : (
        <MaterialFolderGrid folders={currentFolders} onOpen={handleOpenFolder} />
      )}
    </div>
  );
};

export default MaterialsSubTopicContent;
